import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: 'Kup 1, dostań 1',
  [OFFER_TYPE.FREE_ITEM]: 'Darmowa pozycja',
  [OFFER_TYPE.AMOUNT_OFF]: 'Kwota rabatu',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Procent rabatu',
};
